export default "__VITE_PUBLIC_ASSET__16722494__"